@import '../../../constants/spacing.module.less';

.dimension-input {
  // nesting required to beat specificity
  .number-inputs-container {
    display: grid;
    grid-auto-flow: column;
    grid-auto-columns: 1fr;
    gap: @space-8;
  }
}
